import React, { ReactElement } from 'react';
import { Modal } from '@odin-labs/components';
import { getGraphQLError } from 'utils/error';
import { AlertService } from 'components/alertService';
import { TrashIcon } from 'components/icons';
import { useSetDefaultStripePaymentMethodMutation } from 'apollo/generated/client-operations';
import { SetDefaultPaymentMethodModalProps } from './types';

export function SetDefaultPaymentMethodModal(
  props: SetDefaultPaymentMethodModalProps,
): ReactElement {
  const {
    isOpen,
    paymentMethodId,
    contractorId,
    closeModal,
    onClosed,
    refetchQueries,
  } = props;

  const [setDefaultStripePaymentMethod, { loading }] =
    useSetDefaultStripePaymentMethodMutation({
      onCompleted: (): void => {
        AlertService.alert(
          'success',
          'Success',
          'Default Stripe payment method successfully set',
        );
        closeModal();
      },
      onError: (err): void => {
        AlertService.alert(
          'danger',
          'Something went wrong!',
          getGraphQLError(err),
        );
      },
      variables: { input: { contractorId, paymentMethodId } },
      refetchQueries,
    });

  return (
    <Modal
      open={isOpen}
      setOpen={closeModal}
      afterLeave={onClosed}
      size="sm"
      title="Set this payment method as default?"
      titleAlignment="center"
      text="Going forward this would become the default payment method without a specific jobsite override."
      textAlignment="center"
      onAction={setDefaultStripePaymentMethod}
      actionText="Set as default payment method"
      actionButtonTheme="secondary"
      actionIcon={TrashIcon}
      actionButtonWithSpinner={loading}
    />
  );
}
